import { createBrowserRouter, type RouteObject } from "react-router-dom";

import { AppShell } from "./AppShell";
import { AdminPage } from "../pages/AdminPage";
import { DashboardPage } from "../pages/DashboardPage";
import { DepartmentManagementPage } from "../pages/DepartmentManagementPage";
import { CapabilityCenterPage } from "../pages/CapabilityCenterPage";
import { DatasetsPage } from "../pages/DatasetsPage";
import { ExecutionPage } from "../pages/ExecutionPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { ProductCatalogPage } from "../pages/ProductCatalogPage";
import { RunsPage } from "../pages/RunsPage";
import { ReplenishmentPage } from "../pages/ReplenishmentPage";
import { LoginPage } from "../pages/LoginPage";
import { ListingCopywritingPage } from "../pages/ListingCopywritingPage";
import { MyAccountPage } from "../pages/MyAccountPage";
import { UserManagementPage } from "../pages/UserManagementPage";
import { ImagePilotPage } from "../pages/ImagePilotPage";
import { WeeklyReportPage } from "../pages/WeeklyReportPage";
import { OwnerRoute, ProtectedRoute } from "./AuthContext";

export const appRoutes: RouteObject[] = [
  {
    path: "/login",
    Component: LoginPage,
  },
  {
    Component: ProtectedRoute,
    children: [
      {
        path: "/",
        Component: AppShell,
        children: [
          { index: true, Component: DashboardPage },
          { path: "capabilities", Component: CapabilityCenterPage },
          { path: "products", Component: ProductCatalogPage },
          { path: "weekly-report", Component: WeeklyReportPage },
          { path: "replenishment", Component: ReplenishmentPage },
          { path: "images", Component: ImagePilotPage },
          { path: "listing-copywriting", Component: ListingCopywritingPage },
          { path: "runs", Component: RunsPage },
          { path: "runs/:runId", Component: RunsPage },
          { path: "execute/:taskCardCode", Component: ExecutionPage },
          { path: "datasets", Component: DatasetsPage },
          { path: "account", Component: MyAccountPage },
          { path: "users", Component: UserManagementPage },
          {
            Component: OwnerRoute,
            children: [{ path: "departments", Component: DepartmentManagementPage }],
          },
          { path: "admin", Component: AdminPage },
          { path: "*", Component: NotFoundPage },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(appRoutes);
